import * as buffer from 'buffer';

export default buffer.Buffer;
